import Dexie from 'dexie'

export const db = new Dexie('roomsPg')
db.version(11).stores({
  rooms: '++id, roomId, instance_id,phone_number, last_message, unread_count', // Primary key and indexed props
  showedRooms: '++id, roomId, instance_id,phone_number, last_message, unread_count', // Primary key and indexed props
})
